// 说明：原有的 moment / toSingleLine 导入仅服务于已移除的 Pro 授权校验，
// 一并删除以避免无用依赖（moment 体积较大，减少一处引用点）。

/**
 * Converts any value to string.
 *
 * @param {*} value
 * @returns {String}
 */
export function stringify(value) {
  let result;

  switch (typeof value) {
    case 'string':
    case 'number':
      result = `${value}`;
      break;

    case 'object':
      result = value === null ? '' : value.toString();
      break;
    case 'undefined':
      result = '';
      break;
    default:
      result = value.toString();
      break;
  }

  return result;
}

/**
 * Checks if given variable is defined.
 *
 * @param {*} variable Variable to check.
 * @returns {Boolean}
 */
export function isDefined(variable) {
  return typeof variable !== 'undefined';
}

/**
 * Checks if given variable is undefined.
 *
 * @param {*} variable Variable to check.
 * @returns {Boolean}
 */
export function isUndefined(variable) {
  return typeof variable === 'undefined';
}

/**
 * Check if given variable is null, empty string or undefined.
 *
 * @param {*} variable Variable to check.
 * @returns {Boolean}
 */
export function isEmpty(variable) {
  return variable === null || variable === '' || isUndefined(variable);
}

/**
 * Check if given variable is a regular expression.
 *
 * @param {*} variable Variable to check.
 * @returns {Boolean}
 */
export function isRegExp(variable) {
  return Object.prototype.toString.call(variable) === '[object RegExp]';
}

/**
 * 授权信息注入点（保留函数签名，实现为空）。
 *
 * 该内核基线取自 handsontable v6.2.2，采用 MIT 许可（见 vendor/handsontable/LICENSE），
 * 无需任何授权 Key。原实现是针对 "Handsontable Pro" 的商业授权校验，会在控制台与
 * 页面 DOM 注入 "Evaluation version / license key is invalid" 之类的提示——对 MIT
 * 版本而言这些提示既无意义也具误导性，故此处移除，仅保留空实现以维持调用兼容。
 *
 * @param {String} [key] 兼容旧配置项 licenseKey，已忽略。
 * @param {HTMLElement} [element] 表格根元素，已忽略。
 */
// eslint-disable-next-line no-unused-vars
export function _injectProductInfo(key, element) {
  // no-op：MIT 基线无授权校验
}
